import React from "react";
import SettingsSection from "../SettingsSection";
import ChannelPicker from "../ChannelPicker";

export default function ConfessionsSection({
  channels,
  confessions,
  setConfessions,
}) {
  const update = (patch) => setConfessions((prev) => ({ ...prev, ...patch }));

  return (
    <SettingsSection>
      <p className="help-text" style={{ marginBottom: "15px" }}>
        Anonymous confession panel with Discord modals for confess / poll /
        reply. Confession posts stay clean (no buttons). After each new post,
        Kami deletes and reposts the panel so it stays at the bottom of the
        confession channel. After saving settings, run{" "}
        <code>/setup-confessions</code> once to post the panel. Staff log shows
        who submitted each post (public posts stay anonymous).
      </p>

      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          cursor: "pointer",
          marginBottom: "20px",
        }}
      >
        <input
          type="checkbox"
          checked={confessions.enabled}
          onChange={(e) => update({ enabled: e.target.checked })}
        />
        <span style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
          ENABLE CONFESSIONS
        </span>
      </label>

      <label className="input-label">POST CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={confessions.channelId}
        onChange={(v) => update({ channelId: v })}
        types={[0]}
        emptyLabel="None"
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        STAFF LOG CHANNEL (OPTIONAL)
      </label>
      <ChannelPicker
        channels={channels}
        value={confessions.logChannelId}
        onChange={(v) => update({ logChannelId: v })}
        types={[0]}
        emptyLabel="None"
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        DEFAULT EMBED COLOR
      </label>
      <input
        type="text"
        value={confessions.embedColor}
        onChange={(e) => update({ embedColor: e.target.value })}
        className="settings-input"
        placeholder="#4a0e17"
        maxLength={7}
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        COOLDOWN (SECONDS)
      </label>
      <input
        type="number"
        min={0}
        max={3600}
        value={confessions.cooldownSeconds}
        onChange={(e) =>
          update({ cooldownSeconds: Number(e.target.value) || 0 })
        }
        className="settings-input"
      />

      <div
        style={{
          display: "grid",
          gap: "10px",
          margin: "16px 0",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={confessions.allowPolls}
            onChange={(e) => update({ allowPolls: e.target.checked })}
          />
          <span style={{ fontSize: "0.85rem" }}>Allow anonymous polls</span>
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={confessions.allowReplies}
            onChange={(e) => update({ allowReplies: e.target.checked })}
          />
          <span style={{ fontSize: "0.85rem" }}>Allow anonymous replies</span>
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={confessions.allowCustomColor}
            onChange={(e) => update({ allowCustomColor: e.target.checked })}
          />
          <span style={{ fontSize: "0.85rem" }}>
            Allow custom embed colors for Server Patrons / boosters
          </span>
        </label>
      </div>

      <label className="input-label">PANEL TITLE</label>
      <input
        type="text"
        value={confessions.panelTitle}
        onChange={(e) => update({ panelTitle: e.target.value })}
        className="settings-input"
        maxLength={256}
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        PANEL DESCRIPTION
      </label>
      <textarea
        value={confessions.panelDescription}
        onChange={(e) => update({ panelDescription: e.target.value })}
        className="settings-input large-text"
        rows={4}
        maxLength={2000}
      />

      <label className="input-label" style={{ marginTop: "15px" }}>
        PANEL FOOTER
      </label>
      <input
        type="text"
        value={confessions.panelFooter}
        onChange={(e) => update({ panelFooter: e.target.value })}
        className="settings-input"
        maxLength={2048}
      />
    </SettingsSection>
  );
}
